import React, { useState, useEffect, useRef } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Reviews.css";


// Import your arrow SVG icons
import { GrPrevious } from "react-icons/gr";
import { GrNext } from "react-icons/gr";
import { RxStarFilled } from "react-icons/rx"


const Reviews = () => {


  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  const [slideCount, setSlideCount] = useState(0);

  

  useEffect(() => {
    if (sliderRef.current) {
        setSlideCount(sliderRef.current.props.children.length);
    }
}, [sliderRef]);


  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    arrows:false,
    loop:true,
    centerPadding: "80px",
    centerHeight:"120px" ,
    slidesToShow: 3,
    speed: 500,
    initialSlide: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          slidesToScroll: 1,
          infinite: true,
          arrows:false,
          dots: false,
          autoplay: true,
          speed: 500,
          autoplaySpeed: 2000,
        }
      }
    ]
  };

  return (


    <div id='client-sec-2' style={{ background: "#F8F8F8" }}  className='px-48'>
      <p id='text' className='text-black'>TESTIMONIAL</p>
    <div id='client-title' className='flex justify-between items-center'>
      <h2 className='text-black'>WHAT OUR <br/> <span>CLIENT SAID</span> </h2>
    </div>

    <div>
      <div id="review" className="flex justify-between items-center  my-8">
      <p
      className='arrow-btn'
           onClick={()=>{
            sliderRef.current.slickPrev()
           }}
          >
            <GrPrevious color='#000'/>
          </p>
        <div id="review-carousel">

        <Slider
        ref={sliderRef}
        // nextArrow={<CustomNextArrow />}
        {...settings}>

<div id="slide-div">
              <p id='rating'>
              <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
              </p>
               <p>
               We were blown away by the quality of Vwrap's work. Our company vehicles look incredible and we're already seeing an increase in leads and sales as a result.
              </p>
              <p><b>Ms. Saima</b></p>
              {/* <p id='review-img-div'><img id="review-img" src={img}/></p> */}
            </div>

            <div id="slide-div">
              <p id='rating'>
              <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
              </p>
              <p>
              Vwrap helped us take our outdoor advertising to the next level! Their innovative approach to vehicle wrapping allowed us to reach more customers than ever before, and their team was professional and easy to work with.
              </p>
              <p><b>MR. Abbas</b></p>
              {/* <p id='review-img-div'><img id="review-img" className='fixed z-50' src={img}/></p> */}
            </div>


           


            <div id="slide-div">
             <p id='rating'>
             <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
             </p>
              <p>
              Vwrap's attention to detail is unmatched. They took the time to understand our brand and our target audience, and their designs were spot on. We highly recommend their services!
              </p>
              <p><b>MR. Babar</b></p>
              {/* <p id='review-img-div'><img id="review-img" src={img}/></p> */}
            </div>


            <div id="slide-div">
             <p id='rating'>
             <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
             </p>
              <p>
              Working with Vwrap was a breeze. Their team was responsive and flexible, and they went above and beyond to ensure that our campaign was a success. We'll definitely be working with them again!
              </p>
              <p><b>MR. Muzzamil</b></p>
              {/* <p id='review-img-div'><img id="review-img" src={img}/></p> */}
            </div>


            <div id="slide-div">
              <p id='rating'>
              <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
              </p>
               <p>
               We've worked with several outdoor marketing companies in the past, but Vwrap stands out for their creativity and expertise. They transformed our vehicles into eye-catching mobile billboards that have generated buzz and brand awareness.
              </p>
              <p><b >MS. Ayesha</b></p>
              {/* <p id='review-img-div'><img id="review-img" src={img}/></p> */}
            </div>


            <div id="slide-div">
              <p id='rating'>
              <RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/><RxStarFilled color='#FBC213'/>
              </p>
               <p>
               Vwrap's team is made up of true professionals who are passionate about what they do. Their expertise and attention to detail are second to none, and we couldn't be happier with the results of our campaign. Thanks, Vwrap
              </p>
              <p id="strong"><b>Mr. Safeer</b></p>
              {/* <p id='review-img-div'><img id="review-img" src={img}/></p> */}
            </div>
          </Slider>
        
        </div>
        <p
         className='arrow-btn'
           onClick={()=>{
            sliderRef.current.slickNext()
           }}
          >
            <GrNext />
          </p>
      </div>
    </div>
 </div>

    
  );
};

export default Reviews;
